import { questionBankList, questionDifficultyList } from "constants/questionBank";

const initialState = {
  questionBankList: {},
};

const questionBanks = (state = initialState, action) => {
  switch (action.type) {
    case questionBankList:
      return { ...state, questionBankList: action.payload };

    case questionDifficultyList:
      return { ...state, questionDifficultyList: action.payload };

    default:
      return state;
  }
};

export default questionBanks;